// extracted by mini-css-extract-plugin
export default {"imgContain":"VI","content":"WI","titleAndImage":"XI","title":"YI","text":"ZI","rhodeTitle":"aJ","shortHR":"bJ","modal_root":"cJ","x_mark":"eJ","flavorStickModal":"fJ","greenBox":"gJ"};
    if(module.hot) {
      // 1713809678535
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  